const failure = {
  SAVE_FAILURE: 'Max 6 featured voucher',
  EXIST_VOUCHER: 'This featured voucher already exist',
  LIMITED_EVENT_SELECTED_MERCHANT_PART_OF_ACTIVE_EVENT:
    'Unable to create the event – one or more of the selected merchants is already part of an active event. Each merchant can only be assigned to one active event at a time.',
};

export default failure;
